<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-soundwave`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25 6a1 1 0 011 1v34a1 1 0 01-1 1h-2a1 1 0 01-1-1V7a1 1 0 011-1h2zm8 6a1 1 0 011 1v22a1 1 0 01-1 1h-2a1 1 0 01-1-1V13a1 1 0 011-1h2zm-16 0a1 1 0 011 1v22a1 1 0 01-1 1h-2a1 1 0 01-1-1V13a1 1 0 011-1h2zm24 4a1 1 0 011 1v14a1 1 0 01-1 1h-2a1 1 0 01-1-1V17a1 1 0 011-1h2zM9 16a1 1 0 011 1v14a1 1 0 01-1 1H7a1 1 0 01-1-1V17a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconSoundwave',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
